
/** Push the footer to the bottom of the page if it's not already there */
function anchorFooter() {
  var content = document.querySelector('.content');
  content.style.minHeight = 0;

  var footer = document.querySelector('.primary-footer');

  if (!footer) { return; }
  
  var footerBottom = footer.offsetTop + footer.offsetHeight;
  var windowBottom = window.innerHeight;

  if(footerBottom <= windowBottom){
    var spanSize = windowBottom - footerBottom;
    content.style.minHeight = spanSize + content.offsetHeight + 'px';
  }
}

function noActionCurrentPage() {
  const currentPageLinks = document.querySelectorAll('a[aria-current="page"]');

  currentPageLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
    });
  });
}

export { anchorFooter, noActionCurrentPage };
